import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../Redux/Actions/AuthActions';
import './Register.css';
import logo from "../image/bookly_logo.png";

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [localError, setLocalError] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setLocalError("Les mots de passe ne correspondent pas.");
      return;
    }
    setLocalError('');
    dispatch(register({ email, password }, navigate));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 register-background">
      <div className="register-container shadow rounded p-5 text-center">
        <img src={logo} alt="Bookly Logo" className="mb-4 login-logo-img" />
        <h4 className="mb-4 text-secondary font-weight-bold">Créer un compte</h4>

        {localError && (
          <div className="alert alert-danger" role="alert">
            {localError}
          </div>
        )}

        <Form onSubmit={handleRegister}>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Adresse Email</Form.Label>
            <Form.Control
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="votre.email@exemple.com"
              className="input-field"
              value={email}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3 text-start">
            <Form.Label>Mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Au moins 8 caractères"
              className="input-field"
              value={password}
              required
            />
          </Form.Group>

          <Form.Group className="mb-4 text-start">
            <Form.Label>Confirmer le mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              placeholder="Confirmez votre mot de passe"
              className="input-field"
              value={confirmPassword}
              required
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100 btn-submit mb-3">
            S'inscrire
          </Button>

          <div className="d-flex flex-column gap-2 mt-4 text-muted" style={{ fontSize: '13.5px' }}>
            <div className="text-center">
              <span>Déjà inscrit ? <Link to="/ClientLogin">Se connecter</Link></span>
            </div>
            <div className="text-center mt-2 border-top pt-2">
              <span>Vous êtes un établissement ? <Link to="/ProviderRegister" className="text-success font-weight-bold">Devenir Prestataire ➔</Link></span>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Register;
